import { IArticleQuery } from '../interfaces/query/article.query.interface';
import { ArticleCreatedBy } from './article-created-by.model';
import { MaxbrainImage } from '../../image-library/models/maxbrain-image.model';
import { Posting } from 'app/library/posting/models/posting.model';
import { MaxBrainTag } from 'app/library/tag/models/tag.model';
import { ArticleTranslation } from './article-translation.model';

export class Article {
    static label_singular = 'article';
    static label_plural = 'articles';

    static props_to_search = ['contentTitle'];

    id: string;
    uniqueId: string;
    image: MaxbrainImage;
    posting: Posting;
    kind: string;
    validFrom: Date;
    validTo: Date;
    relatedPostings: Posting[];
    tags: MaxBrainTag[];
    url: string;
    translations: ArticleTranslation[];
    translation: ArticleTranslation;
    createdBy: ArticleCreatedBy;
    createdAt: Date;
    language?: string;

    constructor(articleQuery?: IArticleQuery) {
        if (articleQuery) {
            this.id = articleQuery.id.toString();
            this.uniqueId = articleQuery.unique_id;
            this.image = articleQuery.image ? new MaxbrainImage(articleQuery.image) : null;
            this.posting = articleQuery.posting ? new Posting(articleQuery.posting) : null;
            this.kind = articleQuery.kind;
            this.validFrom = articleQuery.valid_from ? new Date(articleQuery.valid_from) : null;
            this.validTo = articleQuery.valid_to ? new Date(articleQuery.valid_to) : null;
            this.relatedPostings = articleQuery.related_postings.map((posting) => new Posting(posting));
            this.tags = articleQuery.tags.map((tag) => new MaxBrainTag(tag));
            this.url = articleQuery.url ? articleQuery.url : null;
            (this.translations = articleQuery.translations ? articleQuery.translations.map((translation) => new ArticleTranslation(translation)) : null),
                (this.translation = articleQuery.translation ? new ArticleTranslation(articleQuery.translation) : null),
                (this.createdBy = articleQuery.created_by ? new ArticleCreatedBy(articleQuery.created_by) : null);
            this.createdAt = articleQuery.created_at ? new Date(articleQuery.created_at) : null;
        }
    }
}
